import React from 'react';
import './shared.css';

const VideoTraining: React.FC = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1>LIVE Video Service &amp; Repair</h1>

        <p>
          Video Service &amp; Repair brought to you by AEuromotive and we’re excited to announce the introduction of
          our Video Training System for all Professional Technician members through the AEuromotive online
          membership program. We plan to strive for improved video quality and more as we progress into the
          future of online diagnostics and repair for our professional technicians by regularly upgrading the
          technology.
        </p>
        <p>
          As an example enjoy this short 3 minute video of what to expect and come back often for further Diagnostic
          and Repair Videos for European cars of all Makes and Models. Have a video request?{' '}
          <a href="/contact">Contact us</a> today and submit the request via our contact form or email us directly.
        </p>

        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', margin: '20px 0' }}>
          <iframe
            src="https://www.youtube.com/embed/a4MZeP58ubM"
            title="AEuromotive Intro"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <p>
          Check out our{' '}
          <a href="/professional-online-video-training" onClick={(e) => e.preventDefault()}>
            Professional Online Video Training
          </a>
        </p>
      </div>
    </div>
  );
};

export default VideoTraining;

